// extracted by mini-css-extract-plugin
module.exports = {"taskSwitch":"styles_taskSwitch__2ezGt"};